import React from "react";
import clsx from "clsx";
import { TableCellProps } from "../types";
import { LabelMono3 } from "../../typography/components/LabelMono";
import TooltipButtonPanel from "../../Tooltip/components/TooltipButtonPanel";

const TableCell: React.FC<TableCellProps> = ({
  className,
  value: { value, highlightValue, link, tooltipCopy },
}) => {
  const valueToRender = tooltipCopy ? (
    <div className="flex gap-1 items-center">
      {value}
      <TooltipButtonPanel
        label={String(value)}
        tooltipCopy={tooltipCopy}
        className="normal-case"
      />
    </div>
  ) : (
    value
  );

  return (
    <td
      className={clsx(
        "whitespace-nowrap py-4 pr-3",
        highlightValue && "text-green-500",
        className,
      )}
    >
      <LabelMono3 as="div">
        {link ? <a href={link}>{valueToRender}</a> : valueToRender}
      </LabelMono3>
    </td>
  );
};

export default TableCell;
